import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FiX, FiMenu } from "react-icons/fi";

import logoDefault from "../../assets/images/logo/LoanDeer.png";
import logoLight from "../../assets/images/logo/LoanDeer.png";
import logoDark from "../../assets/images/logo/LoanDeer.png";
import logoSymbolDark from "../../assets/images/logo/logo-symbol-dark.png";
import logoSymbolLight from "../../assets/images/logo/logo-symbol-light.png";

class Header extends Component {
  constructor(props) {
    super(props);
    this.menuTrigger = this.menuTrigger.bind(this);
    this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
    //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
    window.addEventListener("load", function () {
      console.log("All assets are loaded");
    });
  }

  menuTrigger() {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  }

  CLoseMenuTrigger() {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  }

  render() {
    var elements = document.querySelectorAll(".has-droupdown > a");
    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
    const { logo, color = "default-color" } = this.props;
    let logoUrl;
    if (logo === "light") {
      logoUrl = <img src={logoLight} alt="LoanDeer" />;
    } else if (logo === "dark") {
      logoUrl = <img src={logoDark} alt="LoanDeer" />;
    } else if (logo === "symbol-dark") {
      logoUrl = <img src={logoSymbolDark} alt="LoanDeer" />;
    } else if (logo === "symbol-light") {
      logoUrl = <img src={logoSymbolLight} alt="LoanDeer" />;
    } else {
      logoUrl = <img src={logoDefault} alt="LoanDeer" />;
    }

    return (
      <header
        className={`header-area formobile-menu header--transparent ${color}`}
      >
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">{logoUrl}</a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <ul className="mainmenu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="has-droupdown">
                  <Link to="#tools">Tools</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/mortgage-calculator">Mortgage Calculator</Link>
                    </li>
                    <li>
                      <Link to="/refinance-calculator">
                        Refinance Calculator
                      </Link>
                    </li>
                    <li>
                      <Link to="/prequalify-calculator">
                        PreQualify Calculator
                      </Link>
                    </li>
                    <li>
                      <Link to="/homebuyer-checklist">
                        First-Time Homebuyer Checklist Tool
                      </Link>
                    </li>
                    <li>
                      <Link to="/budget-planning">
                        Budget Planning Tool for Homebuyers
                      </Link>
                    </li>
                    <li>
                      <Link to="/rental-profitability-calculator">
                        Airbnb vs. Long-Term Rental Profitability Calculator
                      </Link>
                    </li>
                    <li>
                      <Link to="/faqs">Common Q&A</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span
                onClick={this.menuTrigger}
                className="menutrigger text-white"
              >
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={this.CLoseMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default Header;
